import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Grid, IconButton, InputAdornment, TextField, Toolbar, Tooltip } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router';

import FixedLinearProgress from '../components/FixedLinearProgress';
import { ContextStore } from '../store/contextStore';
import { debounce } from '../utils';
import CheckboxOptionsSelect from './CheckboxOptionsSelect';

// const useToolbarStyles = makeStyles((theme) => ({
//     hidden: {
//         visibility: 'hidden',
//     },
//     grow: {
//         flexGrow: 1,
//     },
//     rightButton: {
//         marginLeft: theme.spacing(1),
//         marginRight: theme.spacing(1),
//     },
// }));

export const PreTripItemListToolbar = (props) => {
    const history = useHistory();
    const searchQueryRef = React.useRef(null);
    // const dataAPI = React.useContext(DataAPIContext);
    // const classes = useToolbarStyles();
    const { hasPerm } = React.useContext(ContextStore);
    const { resource } = props;
    const [syncActive] = React.useState(false);
    // const [selectedTrip, setSelectedTrip] = React.useState(null);
    // const { enqueueSnackbar } = useSnackbar();

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    const onCreateNewItemBtClick = (ev) => {
        history.push('/pretrip/items/create');
    };


    return (
        <>
            <FixedLinearProgress visibility={syncActive} />

            <Toolbar disableGutters={true} sx={{ minHeight: 0 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={4} container spacing={2} alignItems={'center'} wrap="nowrap">
                        <Grid item xs sm={12}>
                            <TextField
                                variant="filled"
                                label="Search"
                                size="small"
                                onChange={debouncedSearchQueryChangeHandler}
                                inputRef={searchQueryRef}
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Search">
                                                <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {/* [+] at the end of the search row, as on Activities (CP-5563);
                            it used to float over the list's bottom-right corner. */}
                        {props.isSmallScreen && hasPerm('pre_trip_item', 'write') && (
                            <Grid item xs="auto" container justifyContent={'flex-end'}>
                                <Tooltip title={resource === 'pre_trip_item' ? 'New trip item' : 'New category'}>
                                    <Button onClick={resource === 'pre_trip_item' ? onCreateNewItemBtClick : props.onCreateCategory} variant="contained" color="primary">
                                        <AddIcon />
                                    </Button>
                                </Tooltip>
                            </Grid>
                        )}
                    </Grid>
                    {!props.isSmallScreen && props.resource === 'pre_trip_item' && (<Grid item xs={0} sm={5}>
                        <CheckboxOptionsSelect recordListFilters={props.recordListFilters} setRecordListFilters={props.setRecordListFilters} />
                    </Grid>)}

                </Grid>
            </Toolbar>
        </>
    );
};

export default PreTripItemListToolbar;
